import { render } from "./App.vue?vue&type=template&id=5f82876e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f82876e&lang=scss"

import exportComponent from "C:\\Users\\34222\\Desktop\\kuaiyingyong\\vue-deom1\\官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__